import { UrlHandlingStrategy } from '@angular/router';
import { UrlTree } from '@angular/router/src/url_tree';

export const ngXUrls = [
  '/',
  '/lead-generation',
  '/my-account',
  '/blacklist',
  '/integrations/zapier',
  '/reports',
  '/first-steps',
  '/mobile-app',
  '/contacts',
  '/ivr',
  '/account/recharge/confirm',
  '/account/subscription/payment',
  '/get-new-number',
  '/get-first-new-number',
  '/phone-numbers'
];

export class CustomHandlingStrategy implements UrlHandlingStrategy {
  shouldProcessUrl(url: UrlTree) {
    return !!ngXUrls.find(ngXUrl => url.toString().startsWith(ngXUrl));
  }
  extract(url) {
    return url;
  }
  merge(url, whole) {
    return url;
  }
}

export const CustomUrlHandling = { provide: UrlHandlingStrategy, useClass: CustomHandlingStrategy };
